module.exports = __webpack_public_path__ + "static/media/ezgif.5135296c.gif";